import { render, staticRenderFns } from "./ApplicationCommunicationEdit.vue?vue&type=template&id=8e972ce0&"
import script from "./ApplicationCommunicationEdit.vue?vue&type=script&lang=ts&"
export * from "./ApplicationCommunicationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e972ce0')) {
      api.createRecord('8e972ce0', component.options)
    } else {
      api.reload('8e972ce0', component.options)
    }
    module.hot.accept("./ApplicationCommunicationEdit.vue?vue&type=template&id=8e972ce0&", function () {
      api.rerender('8e972ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/applicationCommunication/ApplicationCommunicationEdit.vue"
export default component.exports